/* Copyright (c) 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Box, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { ChartLegend } from "../ChartLegend/ChartLegend";
import { StatusChart } from "../StatusChart/StatusChart";
import { StatusChartItem } from "../types";

type Props = {
  title: string;
  items: StatusChartItem[];
  hasChart?: boolean;
};

export function SummaryCard({ title, items, hasChart = false }: Props) {
  return (
    <Box boxStyle="lightGrey" padding={theme.spacing.spacing04}>
      <Text weight="medium" mb={theme.spacing.spacing07}>
        {title}
      </Text>
      <FlexContainer alignItems="flex-start" gap={theme.spacing.spacing08}>
        <When condition={hasChart}>
          <div css={{ width: "30%" }}>
            <StatusChart items={items} chartLabel="resources" />
          </div>
        </When>
        <ChartLegend items={items} />
      </FlexContainer>
    </Box>
  );
}
